import { Platform } from 'react-native';
import { CaretLeft, ArrowLeft } from '../Icons';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '../../navigationApp/types';
import { ThemedTouchableOpacity } from '../../theme/Components';
import {useDarkMode} from '@app/utils';
import { useAppSelector } from '@app/store/hooks';
import ROUTE from '@app/navigationApp/routes';


type BackButtonProps = NativeStackNavigationProp<PrivateStackParamList , keyof PrivateStackParamList>

const BackButton = ({ navigation , pageName, manualHandle  } : {navigation : BackButtonProps , pageName? :keyof PrivateStackParamList, manualHandle?: Function }) => {
  const isDarkMode = useDarkMode()
  const {showHome, isPLJ} = useAppSelector(state => state.platformParams)
  const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);
  const {userDetails} = useAppSelector(state => state.auth)
  const handleGoBack = () => {
    if (isPLJ && userDetails?.linkedBorrowerAccounts[0]?.accountHolderEmail === null) {
      navigation.navigate(ROUTE.HOME)
    } 
    else if(typeof manualHandle === 'function'){
      manualHandle()
    }
    else if (navigation.canGoBack() && (showHome|| isLMSUser)) {
      navigation.goBack();
    } else {
      console.log('No screen to go back to.');
    }
  };
  return (
    <ThemedTouchableOpacity
      hitSlop={{ left: 10, right: 10, top: 10, bottom: 10 }}
      eventName={pageName ? pageName + '_BACK' : undefined}
      onPress={handleGoBack}>
      {Platform.OS === 'ios' ? (
        <CaretLeft size={20} color={isDarkMode? '#fff':"#000000"} />
      ) : (
        <ArrowLeft size={18} color={isDarkMode? '#fff':"#000000"}  />
      )}
    </ThemedTouchableOpacity>
  );
};

export default BackButton;
